
<div class="whatsapp_float">

  <a target="_blank" href="https://api.whatsapp.com/send?phone=919372656044&text=Hi, I am interested%20in%20Mutual%20Fund%20Investments.%20 Can%20you%20please%20help%20me?">

  <img src="assets/whatsapp-1357489_1920-removebg-preview.png" width="140px" class="whatsapp_float_btn">
</a>

</div>

<router-outlet  (activate)="onActivate()"></router-outlet>
